<template>
  <div>
    <a-card>
      <div :class="getScreen?'align-middle':'m-display-flex space-between align-middle'">
        <div :style="getScreen?'margin:15px':''">
          Type :&nbsp;
          <a-select
            placeholder="Type"
            v-model="selected.type"
            showSearch
            optionFilterProp="children"
            @change="changeTypev0"
            :style="getScreen?'':'width:170px'"
            :class="getScreen?'m-width-full':''"
            :disabled="loading.page"
          >
            <a-select-option v-for="item in typeList" :key="item.value">{{ item.label }}</a-select-option>
          </a-select>
          Period :&nbsp;
          <a-select
            placeholder="Month Start"
            v-model="selected.periode"
            showSearch
            optionFilterProp="children"
            @change="changePeriod"
            :style="getScreen?'':'width:160px'"
            :class="getScreen?'m-width-full':''"
            :disabled="loading.page"
          >
            <a-select-option v-for="item in periodeStartList" :key="item.id" :value="item.id">
              {{ moment(item.month_start).format("YYYY-MM") }} ~ {{ moment(item.month_end).format("YYYY-MM") }}
            </a-select-option>
          </a-select>
          Version :&nbsp;
          <a-select
            placeholder="Filter by Version"
            v-model="selected.version"
            showSearch
            optionFilterProp="children"
            @change="changeVer"
            :style="getScreen?'':'width:130px'"
            :class="getScreen?'m-width-full':''"
            :disabled="loading.page"
          >
            <a-select-option v-for="item in versionList" :key="item.cm_mp_version">{{ item.cm_mp_version }} | {{ item.active_sts=='1'?'Active':'Non Active' }}</a-select-option>
          </a-select>
        </div>
        <div>
          <a-button v-if="!getScreen" type="secondary" icon="reload" @click="refresh()">Refresh</a-button>
          <a-button v-if="isVPF||isKeu" type="primary" class="cbtn-create margin-left" icon ="plus" @click="showCreateDialog()">Create</a-button>
        </div>
      </div>
    </a-card>
    <a-row :gutter="8" :class="getScreen ? 'h_MCMAP-h_col' : 'h_MCMAP'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 9 }">
        <a-collapse v-model="activeKey.header" :activeKey="activeKey.header"
        :class="getScreen?'margin-top':''">
          <a-collapse-panel key="1">
            <span slot="header">
              <div v-if="!getScreen">
                Type: {{ data_header.type_label ? data_header.type_label : "-" }}
                &nbsp;Period: {{ data_header.start ? moment(data_header.start).format("YYYY-MM") : "" }}~{{ data_header.end ? moment(data_header.end).format("YYYY-MM") : "" }}
                &nbsp;Version: {{ selected.version ? selected.version : "-" }}
              </div>
              <div v-else>
                {{ data_header.type_label ? selected.type_label : "-" }} : 
                {{ data_header.start ? moment(data_header.start).format("YYYY-MM") : "" }}~{{ data_header.end ? moment(data_header.end).format("YYYY-MM") : "" }} : 
                {{ selected.version ? selected.version : "-" }}
              </div>
            </span>
            <div class="m-display-flex space-between margin-medium" >
              <div><b>Status : </b><Status class="margin-right" :status="data_header.status=='active' ? 'Active' : (data_header.status?data_header.status.replace('non active', 'NON ACTIVE'):data_header.status)" /></div>
              <div>
                <a-button type="danger" icon="edit" size="small" class="margin-right"
                  v-if="isVPF || isKeu"
                  @click="(e)=>{showEditDialog(e,data_header.id)}"
                  :disabled="loading.page || selected.periode==null || !(data_header.status=='active')">
                  {{getScreen ? '' : 'Edit'}}
                </a-button>
                <a-button type="primary" icon="file" size="small" 
                  @click="gotoManifest(data_header.id)"
                  :disabled="loading.page || selected.periode==null || !data_header.id">
                  {{getScreen ? '' : 'Manifest'}}
                </a-button>
              </div>
            </div>
            <a-table 
              :rowKey="(record, index) => {return index;}"
              :showHeader="false"
              :columns="columns" 
              :data-source="dtl"
              :loading="loading.page"
              :pagination="false"
              class="hdr_plfn" 
              :rowClassName="getclassName"
              bordered>
              <template slot="title" slot-scope="currentPageData">
              
                <!-- <div class="m-display-flex space-between align-middle">
                  <b>Type</b>
                  <span class="row_h">{{ data_header.type_monthly }}</span>
                </div>
                <div class="m-display-flex space-between align-middle">
                  <b>Period</b>
                  <div style="display: flex;max-width: 80%;align-items: center;">
                    <a-date-picker
                      placeholder="Start"
                      v-model="data_header.start"
                      format="MM-YYYY"
                      disabled
                    />
                    &nbsp;to&nbsp;
                    <a-date-picker
                      placeholder="End"
                      v-model="data_header.end"
                      format="MM-YYYY"
                      disabled
                    />
                  </div>
                </div> -->
                <!-- <div class="m-display-flex space-between align-middle row-ecv">
                  <b>Est. CashFlow Value</b>
                  <a-input-number
                    v-model="data_header.est_cashflow_value"
                    class="m-width-full margin-top"
                    style="display: flex;max-width: 50%;text-align:right"
                    :formatter="(value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                    disabled
                  ></a-input-number>
                  <span class="row_h">{{ formatCurrency('IDR', data_header.est_cashflow_value?data_header.est_cashflow_value:0) }}</span>
                </div> -->
                <div class="m-display-flex space-between align-middle">
                  <a-tooltip placement="bottomLeft">
                    <b>Total Plafon&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>Total Plafon is taken from the ceiling amount of the entire directorate&nbsp;<sup><a-icon type="info-circle"/></sup></span>
                    </template>
                  </a-tooltip>
                  <span class="row_h">{{ formatCurrency('IDR', data_header.total_plafon?data_header.total_plafon:0) }}</span>
                </div>
                <div class="m-display-flex space-between align-middle">
                  <a-tooltip placement="bottomLeft">
                    <b>Total Allocated&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>Total allocated is taken from the total value of transactions that have been allocated from all directorates</span>
                    </template>
                  </a-tooltip>
                  <span class="row_h">{{ formatCurrency('IDR', data_header.allocated_value?data_header.allocated_value:0) }}</span>
                </div>
                <div class="m-display-flex space-between align-middle">
                  <a-tooltip placement="bottomLeft">
                    <b>Unallocated Plafon&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>Unallocated Plafon is taken from the total ceiling minus of the total allocated</span>
                    </template>
                  </a-tooltip>
                  <span class="row_h">{{ formatCurrency('IDR', (data_header.total_plafon?data_header.total_plafon:0)-(data_header.allocated_value?data_header.allocated_value:0)) }}</span>
                </div>
                <!-- <div class="m-display-flex space-between align-middle">
                  <a-tooltip placement="bottomLeft">
                    <b>Total Realization&nbsp;<sup><a-icon type="info-circle"/></sup></b>
                    <template slot="title">
                      <span>The total realization is taken from the realization of transactions throughout the directorate<</span>
                    </template>
                  </a-tooltip>
                  <span class="row_h">{{ formatCurrency('IDR', data_header.realization_value) }}</span>
                </div> -->
                <br/>
                <div class="m-display-flex space-between align-middle">
                  <b>Plafon Value Directorate :</b>
                </div>
              </template>
              <template slot="hdr" slot-scope="text, item, index">
                <div class="hdr_plfn_selection" @click="(e)=>{showdtlData(e,item.id_dtl)}">
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }" v-if="!getScreen" style="text-align: right;padding-right:5px"><b>{{ index+1 }}.</b></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 22 }"><b v-if="getScreen">{{ index+1 }}. </b><b>{{ item.directorat }}</b></a-col>
                  </a-row>
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">Plafon<span v-if="getScreen"> :</span></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" style="text-align: right">{{ formatCurrency('IDR', item.plafon_value) }}</a-col>
                  </a-row>
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">Allocated<span v-if="getScreen"> :</span></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" style="text-align: right">{{ formatCurrency('IDR', item.allocated_value) }}</a-col>
                  </a-row>
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">Remaining<span v-if="getScreen"> :</span></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" style="text-align: right">{{ formatCurrency('IDR', Number(item.plafon_value) - Number(item.allocated_value)) }}</a-col>
                  </a-row>
                  <!-- <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">Realized</a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 15 }" style="text-align: right">{{ formatCurrency('IDR', item.realization_value) }}</a-col>
                  </a-row> -->
                </div>
              </template>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 15 }">
        <Details :loading="data_detail.loading" :datasource="data_detail.data" :status="data_header.status" type="monthly"/>
      </a-col>
    </a-row>
    <a-modal
      v-if="modal_create.visible"
      v-model="modal_create.visible"
      :title="(modal_create.mode=='create' ? 'Create':'Edit') + ' Cash Management - Liabilities'"
      :width="getScreen ? '95%' : '700px'"
      :confirmLoading="loading.saveCreate"
      class="cMonthlyfromcreate"
      @ok="handleOkCreate"
      cancelText="Cancel"
      okText="Submit"
      centered
      :maskClosable="false"
    >
    <a-config-provider :locale="getLocalConfigProvider()">
      <a-spin
        tip="Please Wait, its still loading data Allocated Value!"
        :spinning="loading.getalocation"
      >
        <a-form-model ref="entriForm" :model="modal_create.form" :rules="modal_create.rules">
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="Periode:" prop="periode" required>
                <!-- <a-date-picker
                  placeholder="Start"
                  v-model="modal_create.form.start_periode"
                  format="MM-YYYY"
                />
                </a-form-model-item>
                &nbsp;to&nbsp;
                <a-form-model-item prop="end_periode" required>
                  <a-date-picker
                    placeholder="End"
                    v-model="modal_create.form.end_periode"
                    format="MM-YYYY"
                  /> -->
                <a-range-picker
                  :placeholder="['Start month', 'End month']"
                  format="MM-YYYY"
                  :mode="['month','month']"
                  style="width: 100%!important"
                  v-model="modal_create.form.periode"
                  @panelChange="handlePanelChange2"
                  @ok="handlePanelOK"
                  :show-time="{
                    hideDisabledOptions: true,
                  }"
                  :locale="locale"
                  :disabled="modal_create.mode == 'edit'"
                />
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="Type:" prop="type" required>
                <a-select
                  placeholder="Filter by Type"
                  v-model="modal_create.form.type"
                  showSearch
                  optionFilterProp="children"
                  @change="changeType"
                  :disabled="modal_create.mode == 'edit'"
                >
                <a-select-option v-for="item in typeList" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <!-- <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X'?8:12 }">
              <a-form-model-item label="Est Cashflow Value:" prop="actual_value_cashflow" required>
                <a-input-number
                  v-model="modal_create.form.actual_value_cashflow"
                  class="m-width-full"
                  @keydown="onlyNumber"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                  :disabled="modal_create.mode == 'edit'"
                ></a-input-number>
              </a-form-model-item>
            </a-col> -->
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
              <a-form-model-item label="Est. Pipeline:" prop="est_total_pipeline" required>
                <a-input-number
                  v-model="modal_create.form.est_total_pipeline"
                  class="m-width-full"
                  @keydown="onlyNumber"
                  @change="changetotalPipeline"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                  :disabled="modal_create.mode == 'edit'"
                ></a-input-number>
                <!-- <div class="m-form-description-small">
                  <div class="m-display-flex space-between align-middle" slot="header">
                    <span><b>Total Pipeline </b></span>
                    <span><b>{{formatCurrency('IDR',modal_create.form.total_pipeline).replace('Rp','')}}</b></span>
                  </div>
                </div> -->
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
              <a-form-model-item label="Est. Directorate Cost:" prop="est_total_directorateCost" required>
                <a-input-number
                  v-model="modal_create.form.est_total_directorateCost"
                  class="m-width-full"
                  @keydown="onlyNumber"
                  @change="changetotalDirectorateCost"
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                  :disabled="modal_create.mode == 'edit'"
                ></a-input-number>
                <!-- <div class="m-form-description-small">
                  <div class="m-display-flex space-between align-middle" slot="header">
                    <span><b>Total Directorate Cost </b></span>
                    <span><b>{{formatCurrency('IDR',modal_create.form.total_directorateCost).replace('Rp','')}}</b></span>
                  </div>
                </div> -->
              </a-form-model-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-form-model-item label="Total Plafon:" prop="actual_value_cashflow" required>
                <a-input-number
                  v-model="modal_create.form.total_est_contract_value"
                  class="m-width-full"
                  @keydown="onlyNumber"
                  disabled
                  :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                ></a-input-number>
              </a-form-model-item>
            </a-col>
          </a-row>
          <!-- <div v-if="isoverCashflow && modal_create.form.type">
            <small style="color:red"> 
              {{
              '* Total Plafon is not match with Est. Cashflow Value!'
              }}
            </small>
          </div>
          <div v-if="isoverPipeline && modal_create.form.type">
            <small style="color:red"> 
              {{
              '* Total of Pipeline is not match with Total Pipeline!'
              }}
            </small>
          </div>
          <div v-if="isoverDirectorateCost && modal_create.form.type">
            <small style="color:red"> 
              {{
              '* Total of Directorate Cost is not match with Total Directorate Cost!'
              }}
            </small>
          </div> -->
          <a-card class="margin-top">
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <b><u>Marketing:</u></b>
                <a-row :gutter="8" class="m-form-description-small">
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }">
                    <a-form-model-item prop="marketing" label="Allocated" class="mdl_input">
                      <a-input-number
                        v-model="modal_create.form.allocatedMarketing"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                      <!-- <div class="m-form-description-bold">Allocated value : {{ modal_create.form.allocatedMarketing }}</div> -->
                      
                    </a-form-model-item>
                    <a-form-model-item prop="marketingListAPCost" label="Mon. List AP" :class="!getScreen ? 'mdl_input' : ''">
                      <a-input-number
                        v-model="modal_create.form.marketingListAPCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type!='X_ABAIKAN_X'">
                    <a-form-model-item prop="marketing" label="Plafon">
                      <a-input-number
                        v-model="modal_create.form.marketing"
                        class="m-width-full"
                        :min="modal_create.form.allocatedMarketing+modal_create.form.marketingListAPCost"
                        @keydown="onlyNumber"
                        @change="recountPlafon"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                      <!-- <div class="m-form-description-bold">Allocated value : {{ modal_create.form.allocatedMarketing }}</div> -->
                      
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="marketing" label="Pipeline Plafon">
                      <a-input-number
                        v-model="modal_create.form.marketingPipeline"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountPipeline"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                      <!-- <div class="m-form-description-bold">Allocated value : {{ modal_create.form.allocatedMarketing }}</div> -->
                      
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="marketing" label="Directorate Cost">
                      <a-input-number
                        v-model="modal_create.form.marketingDirectorateCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountDirectorateCost"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                      <!-- <div class="m-form-description-bold">Allocated value : {{ modal_create.form.allocatedMarketing }}</div> -->
                      
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="8" class="margin-top">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <b><u>Corporate:</u></b>
                <a-row :gutter="8" class="m-form-description-small">
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }">
                    <a-form-model-item prop="corporate" label="Allocated Value" class="mdl_input">
                      <a-input-number
                        v-model="modal_create.form.allocatedCorporate"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                    <a-form-model-item prop="corporateListAPCost" label="Mon. List AP" :class="!getScreen ? 'mdl_input' : ''">
                      <a-input-number
                        v-model="modal_create.form.corporateListAPCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type!='X_ABAIKAN_X'">
                    <a-form-model-item prop="corporate" label="Plafon">
                      <a-input-number
                        v-model="modal_create.form.corporate"
                        class="m-width-full"
                        :min="modal_create.form.allocatedCorporate+modal_create.form.corporateListAPCost"
                        @keydown="onlyNumber"
                        @change="recountPlafon"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="corporate" label="Pipeline Plafon">
                      <a-input-number
                        v-model="modal_create.form.corporatePipeline"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountPipeline"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="corporate" label="Directorate Cost">
                      <a-input-number
                        v-model="modal_create.form.corporateDirectorateCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountDirectorateCost"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="8" class="margin-top">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <b><u>Finance:</u></b>
                <a-row :gutter="8" class="m-form-description-small">
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }">
                    <a-form-model-item prop="finance" label="Allocated Value" class="mdl_input">
                      <a-input-number
                        v-model="modal_create.form.allocatedFinance"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                    <a-form-model-item prop="financeListAPCost" label="Mon. List AP" :class="!getScreen ? 'mdl_input' : ''">
                      <a-input-number
                        v-model="modal_create.form.financeListAPCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type!='X_ABAIKAN_X'">
                    <a-form-model-item prop="finance" label="Plafon">
                      <a-input-number
                        v-model="modal_create.form.finance"
                        class="m-width-full"
                        :min="modal_create.form.allocatedFinance+modal_create.form.financeListAPCost"
                        @keydown="onlyNumber"
                        @change="recountPlafon"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="finance" label="Pipeline Plafon">
                      <a-input-number
                        v-model="modal_create.form.financePipeline"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountPipeline"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="finance" label="Directorate Cost">
                      <a-input-number
                        v-model="modal_create.form.financeDirectorateCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountDirectorateCost"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="8" class="margin-top">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <b><u>Operation:</u></b>
                <a-row :gutter="8" class="m-form-description-small">
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }">
                    <a-form-model-item prop="operation" label="Allocated Value" class="mdl_input">
                      <a-input-number
                        v-model="modal_create.form.allocatedOperation"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                    <a-form-model-item prop="operationListAPCost" label="Mon. List AP" :class="!getScreen ? 'mdl_input' : ''">
                      <a-input-number
                        v-model="modal_create.form.operationListAPCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type!='X_ABAIKAN_X'">
                    <a-form-model-item prop="operation" label="Plafon">
                      <a-input-number
                        v-model="modal_create.form.operation"
                        class="m-width-full"
                        :min="modal_create.form.allocatedOperation+modal_create.form.operationListAPCost"
                        @keydown="onlyNumber"
                        @change="recountPlafon"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="operation" label="Pipeline Plafon">
                      <a-input-number
                        v-model="modal_create.form.operationPipeline"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountPipeline"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="operation" label="Directorate Cost">
                      <a-input-number
                        v-model="modal_create.form.operationDirectorateCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountDirectorateCost"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="8" class="margin-top">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <b><u>Technology:</u></b>
                <a-row :gutter="8" class="m-form-description-small">
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }">
                    <a-form-model-item prop="technology" label="Allocated Value" class="mdl_input">
                      <a-input-number
                        v-model="modal_create.form.allocatedTechnology"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                    <a-form-model-item prop="technologyListAPCost" label="Mon. List AP" :class="!getScreen ? 'mdl_input' : ''">
                      <a-input-number
                        v-model="modal_create.form.technologyListAPCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type!='X_ABAIKAN_X'">
                    <a-form-model-item prop="technology" label="Plafon">
                      <a-input-number
                        v-model="modal_create.form.technology"
                        class="m-width-full"
                        :min="modal_create.form.allocatedTechnology+modal_create.form.technologyListAPCost"
                        @keydown="onlyNumber"
                        @change="recountPlafon"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="technology" label="Pipeline Plafon">
                      <a-input-number
                        v-model="modal_create.form.technologyPipeline"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountPipeline"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="technology" label="Directorate Cost">
                      <a-input-number
                        v-model="modal_create.form.technologyDirectorateCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountDirectorateCost"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row :gutter="8" class="margin-top">
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <b><u>International Business Development:</u></b>
                <a-row :gutter="8" class="m-form-description-small">
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }">
                    <a-form-model-item prop="ibd" label="Allocated Value" class="mdl_input">
                      <a-input-number
                        v-model="modal_create.form.allocatedIbd"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                    <a-form-model-item prop="ibdListAPCost" label="Mon. List AP" :class="!getScreen ? 'mdl_input' : ''">
                      <a-input-number
                        v-model="modal_create.form.ibdListAPCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        disabled
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type!='X_ABAIKAN_X'">
                    <a-form-model-item prop="ibd" label="Plafon">
                      <a-input-number
                        v-model="modal_create.form.ibd"
                        class="m-width-full"
                        :min="modal_create.form.allocatedIbd+modal_create.form.ibdListAPCost"
                        @keydown="onlyNumber"
                        @change="recountPlafon"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="ibd" label="Pipeline Plafon">
                      <a-input-number
                        v-model="modal_create.form.ibdPipeline"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountPipeline"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: modal_create.form.type=='X_ABAIKAN_X' ? 8 : 12 }" v-if="modal_create.form.type=='X_ABAIKAN_X'">
                    <a-form-model-item prop="ibd" label="Directorate Cost">
                      <a-input-number
                        v-model="modal_create.form.ibdDirectorateCost"
                        class="m-width-full"
                        :min="0"
                        @keydown="onlyNumber"
                        @change="recountDirectorateCost"
                        :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                      ></a-input-number>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-card>
          <a-form-model-item label="Upload File Support">
            <a-upload :showUploadList="true" :fileList="modal_create.fileList"
              v-model="modal_create.form.document_support" accept=".jpg, .png, .pdf" :remove="handleRemove" :beforeUpload="beforeUpload">
              <a-button> <a-icon type="upload" />Select File </a-button>
            </a-upload>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
      <template slot="footer">
        <a-button key="back" type="danger" @click="handleCancelCreate">
          Cancel
        </a-button>
        <a-button key="submit" type="primary" 
        :loading="loading.saveCreate" 
        @click="handleOkCreate"
        :disabled="modal_create.form.total_est_contract_value>modal_create.form.actual_value_cashflow || isovervalue || isoverCashflow
        ||isoverDirectorateCost || isoverPipeline"
        >
          Submit
        </a-button>
      </template>
    </a-config-provider>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import GlobalMethod from "@/mixins/GlobalMethod.js"
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import Details from "./monthlyLiabilities_detail"
import _ from "lodash";
import locale from 'ant-design-vue/es/date-picker/locale/en_US';

export default {
  name: "monthlyPlafon",
  components: {
    Details,
  },
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    let validatePlafon = (rule, value, callback) => {
      if (value.toString()=='') {
        callback(new Error("value can't be empty !"));
      } else {
        let res = true
        if(rule.field=='marketing' && Number(value)<this.modal_create.form.allocatedMarketing){
          res = false
        }else if(rule.field=='corporate' && Number(value)<this.modal_create.form.allocatedCorporate){
          res = false
        }else if(rule.field=='finance' && Number(value)<this.modal_create.form.allocatedFinance){
          res = false
        }else if(rule.field=='operation' && Number(value)<this.modal_create.form.allocatedOperation){
          res = false
        }else if(rule.field=='technology' && Number(value)<this.modal_create.form.allocatedTechnology){
          res = false
        }else if(rule.field=='ibd' && Number(value)<this.modal_create.form.allocatedIbd){
          res = false
        }
        if (!res)
          callback(new Error("Value must be more than allocated value!"));
      }

      callback();
    };
    return {
      locale,
      loading:{
        page: false,
        saveCreate: false,
        getalocation: false
      },
      search: null,
      periode: null,
      periodeStartList: [],
      periodeOri: [],
      typeList: [],
      versionList: [],
      versionOri: [],
      header: null,
      dtl: null,
      selected:{
        periode:null,
        periode_start:null,
        periode_end:null,
        type:null,
        version: null
      },
      columns:[
        {
          title: 'hdr',
          scopedSlots: { customRender: 'hdr' },
        },
      ],
      data_header: {
        cashflow_value: 0,
        est_contract_value: 0,
        total_allocated: 0,
        total_plafon: 0, 
        total_realization: 0
      },
      data_detail:{
        loading: false,
        data: []
      },
      activeKey: {
        header: 1
      },
      modal_create:{
        mode: '',
        visible: false,
        form:{
          type: null,
          start_periode: null,
          end_periode: null,
          periode: [null,null],
          actual_value_cashflow: null,
          total_est_contract_value: 0,
          est_total_pipeline: null,
          total_pipeline: null,
          est_total_directorateCost: null,
          total_directorateCost:null,
          marketing: null,
          corporate: null,
          finance: null,
          operation: null,
          technology: null,
          ibd: null,
          marketingPipeline: null,
          corporatePipeline: null,
          financePipeline: null,
          operationPipeline: null,
          technologyPipeline: null,
          ibdPipeline: null,
          marketingDirectorateCost: null,
          corporateDirectorateCost: null,
          financeDirectorateCost: null,
          operationDirectorateCost: null,
          technologyDirectorateCost: null,
          ibdDirectorateCost: null,
          allocatedMarketing: null,
          allocatedCorporate: null,
          allocatedFinance: null,
          allocatedOperation: null,
          allocatedTechnology: null,
          allocatedIbd: null,

          marketingListAPCost: null,
          corporateListAPCost: null,
          financeListAPCost: null,
          operationListAPCost: null,
          technologyListAPCost: null,
          ibdListAPCost: null,

        },
        rules:{
          start_periode: [{ required: true, trigger: "change" }],
          end_periode: [{ required: true, trigger: "change" }],
          periode: [{ required: true, trigger: "change" }],
          marketing: [{ required: true, trigger: "change", validator: validatePlafon }],
          marketingListAPCost: [{ required: true, trigger: "change" }],
          corporate: [{ required: true, trigger: "change", validator: validatePlafon }],
          corporateListAPCost: [{ required: true, trigger: "change" }],
          finance: [{ required: true, trigger: "change", validator: validatePlafon }],
          financeListAPCost: [{ required: true, trigger: "change" }],
          operation: [{ required: true, trigger: "change", validator: validatePlafon }],
          operationListAPCost: [{ required: true, trigger: "change" }],
          technology: [{ required: true, trigger: "change", validator: validatePlafon }],
          technologyListAPCost: [{ required: true, trigger: "change" }],
          ibd: [{ required: true, trigger: "change", validator: validatePlafon }],
          ibdListAPCost: [{ required: true, trigger: "change" }],
        },
        fileList: [],
      },
      allowtoFillDataFetching: false
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
      "getStandartFormatDate",
    ]),
    isVPF(){
      return this.$route.path.includes('/vpf') ? true :false
    },
    isOPC(){
      let temp = false
      this.getAuth.divisi.forEach(element => {
        if(element=='Operation Planning and Control')
        temp = true
      });
      return temp
    },
    isKeu(){
      let temp = false
      this.getAuth.divisi.forEach(element => {
        if(element.toLowerCase()=='keuangan')
        temp = true
      });
      return temp
    },
    isovervalue(){
      return (this.modal_create.form.marketing>=this.modal_create.form.allocatedMarketing &&
      this.modal_create.form.corporate>=this.modal_create.form.allocatedCorporate &&
      this.modal_create.form.finance>=this.modal_create.form.allocatedFinance &&
      this.modal_create.form.operation>=this.modal_create.form.allocatedOperation &&
      this.modal_create.form.technology>=this.modal_create.form.allocatedTechnology &&
      this.modal_create.form.ibd>=this.modal_create.form.allocatedIbd) ? false : true
    },
    isoverCashflow(){ 
      return this.modal_create.form.actual_value_cashflow<this.modal_create.form.total_est_contract_value
    },
    isoverPipeline(){
      return (this.modal_create.form.marketingPipeline+
      this.modal_create.form.corporatePipeline+
      this.modal_create.form.financePipeline+
      this.modal_create.form.operationPipeline+
      this.modal_create.form.technologyPipeline+
      this.modal_create.form.ibdPipeline)!=this.modal_create.form.est_total_pipeline
    },
    isoverDirectorateCost(){
      return (this.modal_create.form.marketingDirectorateCost+
      this.modal_create.form.corporateDirectorateCost+
      this.modal_create.form.financeDirectorateCost+
      this.modal_create.form.operationDirectorateCost+
      this.modal_create.form.technologyDirectorateCost+
      this.modal_create.form.ibdDirectorateCost)!=this.modal_create.form.est_total_directorateCost
    }
  },
  methods:{
    moment,
    async fetch(){
      this.loading.page = true

      let params = {
        jenis:"liability",
      }
      if(this.selected.type)
        params['type'] = this.selected.type
      
      if(this.selected.periode){
        params['month_start'] = this.selected.periode.split("~")[1]
        params['month_end'] = this.selected.periode.split("~")[2]
      }
      if(this.selected.version)
        params['version'] = this.selected.version

      await this.asyncAxiosGet("plafon",
        this.getAuth, params
      )
      .then((res) => {
        //combo type
        this.typeList = res.filter_type

        //combo period
        let tempperiod = res.filter_periode
        tempperiod.forEach((element) => {
          element.id= element.type_monthly+"~"+element.month_start+"~"+element.month_end
        });
        if(tempperiod.length>0 && this.selected.type){
          this.periodeStartList = tempperiod.filter((item)=>
            item.type_monthly==res.header[0].type_monthly
          )
        }
        this.periodeOri = tempperiod
        //combo version
        this.versionOri = res.filter_version

        if(res.header.length>0 && this.allowtoFillDataFetching){          
          this.data_header = res.header[0]
          this.dtl = res.dtl         

          this.data_header.start = res.header[0].month_start
          this.data_header.end = res.header[0].month_end
        }else{
          this.data_header = []
          this.dtl = []
          // this.displayMessageValue("basic-info", res.message);
        }
        this.loading.page = false
      })
    },
    rerenderfocusedRow(e){
      let a = document.getElementsByClassName("isfocused");
      if(a.length>0){
        for (let index = 0; index < a.length; index++) {
          a[index].classList.remove("isfocused");
        }
      }
      if(e!=null)
        e.target.parentElement.parentElement.classList.add("isfocused");
    },
    async showdtlData(e,id){
      this.rerenderfocusedRow(e)
      if(this.getScreen)
        this.activeKey.header = null
      
      if(this.isOPC){
        let temp = this.dtl.filter((item)=>item.id_dtl==id)
        if(temp.length>0 && temp[0].directorat!='Operation'){
          this.displayMessageValue("basic-warning", "Access Denied!");
          return;
        }
      }

      this.data_detail.loading = true
      await this.asyncAxiosGet("plafon/detil",
        this.getAuth, {
          jenis: 'liability',
          id_dtl: id,
          id: this.data_header.id
        }
      )
      .then((res) => {
        this.data_detail.data= {
          allocation: res.allocation[0],
          allocated: res.allocated,
          allowDragDrop: res.allow_access=="1" ? true : false
        }
        this.data_detail.data.allocated.forEach((element, index) => {
          element['shorting'] = index+1
          element['isDroped'] = false
        });
        this.data_detail.loading = false
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    // getlabelperiod(val){
    //   let a = "";
    //   a = this.periode ? this.periode.filter((item) => item.id_cm_mp==val) : []
    //   if(a && a.length>0){
    //     a = a[0].type_monthly
    //     +" | "+
    //     this.moment(a[0].month_start).format('YYYY-MM')
    //     +" to "+
    //     this.moment(a[0].month_end).format('YYYY-MM')
    //     +" | Version "+
    //     a[0].cm_mp_version
    //   }
    //   return a
    // },
    changeTypev0(val){
      this.selected.periode = null
      this.selected.version = null

      this.periodeStartList = this.periodeOri.filter((item)=>item.type_monthly==val)
      
      let tempdt = []
      if(this.periodeStartList.length>0){
        tempdt = this.periodeStartList.filter((item)=>
          moment().startOf('month')>=moment(item.month_start) && moment().startOf('month')<=moment(item.month_end))
        if(tempdt.length>0){
          this.selected.periode = tempdt[0].id

        }
      }

      if(this.selected.periode){
        // this.versionList = this.versionOri.filter((item)=>
        //   item.type==val && item.month_start==tempdt.month_start && item.month_end==tempdt.month_end)
        this.changePeriod()
      }else{
        this.versionList = []
      }

      this.data_header = []
      this.dtl = []
      this.data_detail.data = []
    },
    changePeriod(){
      this.data_detail.loading = false
      this.data_detail.data = []

      let st = this.selected.periode.split("~")
      this.versionList = this.versionOri.filter((item)=>
        item.type==this.selected.type &&
        item.month_start==st[1] && item.month_end==st[2]
      )

      this.selected.version = null
      if(this.versionList.length){
        this.versionList = this.versionOri.filter((item)=>item.type==st[0] && item.month_start==st[1] && item.month_end==st[2])
        if(this.versionList.length>0){
          let tempver = this.versionList.filter((item)=>item.active_sts=='1')
          if( tempver.length>0){
            this.selected.version = tempver[0].cm_mp_version
            this.changeVer()
          }
        }
      }

      this.data_header = []
      this.dtl = []
      this.data_detail.data = []
      this.rerenderfocusedRow(null)
    },
    changeVer(){
      this.data_detail.loading = false
      this.data_detail.data = []
      this.rerenderfocusedRow(null)
      this.allowtoFillDataFetching = true
      this.fetch()
    },
    showCreateDialog(){
      this.clearModalForm()
      this.modal_create.mode = 'create'
      this.modal_create.visible = true
    },
    showEditDialog(e){
      e.stopPropagation(); 
      this.clearModalForm()
      this.modal_create.mode = 'edit'
      this.modal_create.form.type = this.data_header.type_monthly
      this.modal_create.form.start_periode = this.data_header.start
      this.modal_create.form.end_periode = this.data_header.end
      this.modal_create.form.periode = [this.data_header.start, this.data_header.end]
      this.changeType()

      // this.modal_create.form.actual_value_cashflow = Number(this.data_header.est_cashflow_value)
      // this.modal_create.form.total_est_contract_value = 0
      // this.dtl.forEach(element => {
      //   if(element.directorat.toLowerCase()=='marketing'){
      //     this.modal_create.form.marketing = Number(element.plafon_value)
      //     this.modal_create.form.allocatedMarketing= Number(element.allocated_value)
      //   }else if(element.directorat.toLowerCase()=='corporate'){
      //     this.modal_create.form.corporate = Number(element.plafon_value)
      //     this.modal_create.form.allocatedCorporate= Number(element.allocated_value)
      //   }else if(element.directorat.toLowerCase()=='finance'){
      //     this.modal_create.form.finance = Number(element.plafon_value)
      //     this.modal_create.form.allocatedFinance= Number(element.allocated_value)
      //   }else if(element.directorat.toLowerCase()=='operation'){
      //     this.modal_create.form.operation = Number(element.plafon_value)
      //     this.modal_create.form.allocatedOperation= Number(element.allocated_value)
      //   }else if(element.directorat.toLowerCase()=='technology'){
      //     this.modal_create.form.technology = Number(element.plafon_value)
      //     this.modal_create.form.allocatedTechnology= Number(element.allocated_value)
      //   }else if(element.directorat.toLowerCase()=='ibd'){
      //     this.modal_create.form.ibd = Number(element.plafon_value)
      //     this.modal_create.form.allocatedIbd= Number(element.allocated_value)
      //   }
      // });
      this.recountPlafon()
      this.modal_create.fileList = []

      // this.changeType()
      this.modal_create.visible = true
    },
    handleOkCreate(){
      this.$refs.entriForm.validate((valid) => {
        // if (!valid || this.isovervalue || this.isoverCashflow
        // || this.isoverDirectorateCost || this.isoverPipeline) {
          if (!valid || this.isovervalue) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        // data.append("start_periode", this.moment(this.modal_create.form.start_periode).format(this.getStandartFormatDate));
        // data.append("end_periode", this.moment(this.modal_create.form.end_periode).format(this.getStandartFormatDate));
        data.append("type", this.modal_create.form.type);
        data.append("start_periode", this.moment(this.modal_create.form.periode[0]).format(this.getStandartFormatDate));
        data.append("end_periode", this.moment(this.modal_create.form.periode[1]).format(this.getStandartFormatDate));
        data.append("actual_value_cashflow", this.modal_create.form.actual_value_cashflow);
        data.append("total_est_contract_value", this.modal_create.form.actual_value_cashflow);
        data.append("TotalPlafonMarketing", this.modal_create.form.marketing);
        data.append("TotalPlafonCorporate", this.modal_create.form.corporate);
        data.append("TotalPlafonFinance", this.modal_create.form.finance);
        data.append("TotalPlafonOperation", this.modal_create.form.operation);
        data.append("TotalPlafonTechnology", this.modal_create.form.technology);
        data.append("TotalPlafonIbd", this.modal_create.form.ibd);

        if(this.modal_create.fileList.length>0)
          data.append("document_support", this.modal_create.fileList[0]);

        let url = "plafon/liability"
        if(this.modal_create.mode=='edit'){
          url = "plafon/liability_edit"
          data.append("id", this.data_header.id);
        }

        this.loading.saveCreate = true
        this.asyncAxiosPost(url, "formdata", this.getAuth, data)
        .then((response) => {
          this.displayMessageValue("success-other", response.message);
          if(this.modal_create.mode=='edit'){
            this.$router.go(0)
          }else{
            this.loading.saveCreate = false
            this.modal_create.visible = false
            if(this.modal_create.mode!='edit') this.setSelectedtoNull()
            this.fetch()
          }
        })
        .catch((error)=>{
          this.loading.saveCreate = false
        })
      })
    },
    handleCancelCreate(){
      this.clearModalForm();
      this.modal_create.visible = false
    },
    clearModalForm() {
      this.modal_create.form.type = null
      this.modal_create.form.periode = null
      this.clearDetailModalForm();
    },
    clearDetailModalForm() {
      this.modal_create.form.actual_value_cashflow = null
      this.modal_create.form.total_est_contract_value = 0
      this.modal_create.form.marketing = null
      this.modal_create.form.corporate = null
      this.modal_create.form.finance = null
      this.modal_create.form.operation = null
      this.modal_create.form.technology = null
      this.modal_create.form.ibd = null

      this.modal_create.form.allocatedMarketing = 0
      this.modal_create.form.allocatedCorporate = 0
      this.modal_create.form.allocatedFinance = 0
      this.modal_create.form.allocatedOperation = 0
      this.modal_create.form.allocatedTechnology = 0
      this.modal_create.form.allocatedIbd = 0

      this.modal_create.form.marketingListAPCost = null;
      this.modal_create.form.corporateListAPCost = null;
      this.modal_create.form.financeListAPCost = null;
      this.modal_create.form.operationListAPCost =  null;
      this.modal_create.form.technologyListAPCost = null;
      this.modal_create.form.ibdListAPCost = null;
      this.modal_create.fileList = []
    },
    gotoManifest(id){
      let page = "_otherpage";
      if(this.isVPF){
        page = 'MonthlyAnnualManifest_Vpf'
      } else if(this.$route.path.includes("/financialControl")){
         page = 'MonthlyAnnualManifestFin'
      } else if(this.$route.path.includes("/opc")){
        page = 'MonthlyAnnualManifestOPC'
      } else if(this.$route.path.includes("/keuangan/")){
        page = 'MonthlyAnnualManifestKeu'
      } else if(this.$route.path.includes("/directorate-delegation/")){
        page = 'MonthlyAnnualManifestDirDel'
      }else{
        page = 'MonthlyAnnualManifestDir'
      }
      this.$router.push({ name: page, params: { id: id, type: "3" } });
    },
    getclassName(){
      return 'option_plfn'
    },
    setPriorityPlafon(item){
      let id = item.id[0]
      let jenis = item.id[1]
      let rowIndex = item.index
      let selectData = this.data_detail.data.yet_allocated.filter((el)=> el.id_trans==id);
      selectData[0]['shorting'] = rowIndex+1
      let addedData = this.data_detail.data.allocated
      let total = _.sumBy(addedData, function (val) {return Number(val.value_kurs)})

      let remainingPlafon = Number(this.data_detail.data.allocation.plafon_value)-Number(this.data_detail.data.allocation.allocated_value)
      if(total>remainingPlafon){
        Event.$emit("cancelDrugPriorityplafon", {
          from: item.item,
          to: item.clone
        });
      }else{
        Event.$emit("approveDrugPriorityplafon", {
          from: item.item,
          to: item.clone
        });

        //regenerate shorting priority
        addedData.forEach(element => {
          if((element.shorting-1)>=rowIndex){
            element.shorting = element.shorting+1
          }
        });
        addedData = [...this.data_detail.data.allocated, selectData[0]]
        addedData = _.orderBy(addedData, ['shorting'], ['asc'])

        this.data_detail.data.allocated = addedData
      }
    },
    setShortingPriorityPlafon(item){
      this.data_detail.data.allocation = item.allocation[0]
      this.data_detail.data.allocated = []
      this.data_detail.data.allocated = item.allocated
      this.data_detail.data.allocated.forEach((element,index) => {
        element.shorting = index+1
      });
      this.fetch()
    },
    unSetPriorityPlafon(item){
    },
    recountPlafon(){
      let a = 
      (this.modal_create.form.marketing ? this.modal_create.form.marketing : 0)+
      (this.modal_create.form.corporate ? this.modal_create.form.corporate : 0)+
      (this.modal_create.form.finance ? this.modal_create.form.finance : 0)+
      (this.modal_create.form.operation ? this.modal_create.form.operation : 0)+
      (this.modal_create.form.technology ? this.modal_create.form.technology : 0)+
      (this.modal_create.form.ibd ? this.modal_create.form.ibd : 0)
      this.modal_create.form.total_est_contract_value = a?a:0

      this.modal_create.form.marketing==null ? this.modal_create.form.marketing=0 : false
      this.modal_create.form.corporate==null ? this.modal_create.form.corporate=0 : false
      this.modal_create.form.finance==null ? this.modal_create.form.finance=0 : false
      this.modal_create.form.operation==null ? this.modal_create.form.operation=0 : false
      this.modal_create.form.technology==null ? this.modal_create.form.technology=0 : false 
      this.modal_create.form.ibd==null ? this.modal_create.form.ibd=0 : false 
    },
    recountPipeline(){
      // this.modal_create.form.marketingPipeline==null ? this.modal_create.form.marketingPipeline=0 : false
      // this.modal_create.form.corporatePipeline==null ? this.modal_create.form.corporatePipeline=0 : false
      // this.modal_create.form.financePipeline==null ? this.modal_create.form.financePipeline=0 : false
      // this.modal_create.form.operationPipeline==null ? this.modal_create.form.operationPipeline=0 : false
      // this.modal_create.form.technologyPipeline==null ? this.modal_create.form.technologyPipeline=0 : false
      // this.modal_create.form.ibdPipeline==null ? this.modal_create.form.ibdPipeline=0 : false

      // this.modal_create.form.marketing=this.modal_create.form.marketingPipeline+this.modal_create.form.marketingDirectorateCost
      // this.modal_create.form.corporate=this.modal_create.form.corporatePipeline+this.modal_create.form.corporateDirectorateCost
      // this.modal_create.form.finance=this.modal_create.form.financePipeline+this.modal_create.form.financeDirectorateCost
      // this.modal_create.form.operation=this.modal_create.form.operationPipeline+this.modal_create.form.operationDirectorateCost
      // this.modal_create.form.technology=this.modal_create.form.technologyPipeline+this.modal_create.form.technologyDirectorateCost
      // this.modal_create.form.ibd=this.modal_create.form.ibdPipeline+this.modal_create.form.ibdDirectorateCost

      // this.modal_create.form.total_pipeline=this.modal_create.form.marketingPipeline+
      // this.modal_create.form.corporatePipeline+this.modal_create.form.financePipeline
      // this.modal_create.form.operationPipeline+this.modal_create.form.technologyPipeline
      // this.modal_create.form.operationPipeline+this.modal_create.form.ibdPipeline
    },
    recountDirectorateCost(){
      // this.modal_create.form.marketingDirectorateCost==null ? this.modal_create.form.marketingDirectorateCost=0 : false
      // this.modal_create.form.corporateDirectorateCost==null ? this.modal_create.form.corporateDirectorateCost=0 : false
      // this.modal_create.form.financeDirectorateCost==null ? this.modal_create.form.financeDirectorateCost=0 : false
      // this.modal_create.form.operationDirectorateCost==null ? this.modal_create.form.operationDirectorateCost=0 : false
      // this.modal_create.form.technologyDirectorateCost==null ? this.modal_create.form.technologyDirectorateCost=0 : false
      // this.modal_create.form.ibdDirectorateCost==null ? this.modal_create.form.ibdDirectorateCost=0 : false

      // this.modal_create.form.marketing=this.modal_create.form.marketingPipeline+this.modal_create.form.marketingDirectorateCost
      // this.modal_create.form.corporate=this.modal_create.form.corporatePipeline+this.modal_create.form.corporateDirectorateCost
      // this.modal_create.form.finance=this.modal_create.form.financePipeline+this.modal_create.form.financeDirectorateCost
      // this.modal_create.form.operation=this.modal_create.form.operationPipeline+this.modal_create.form.operationDirectorateCost
      // this.modal_create.form.technology=this.modal_create.form.technologyPipeline+this.modal_create.form.technologyDirectorateCost
      // this.modal_create.form.ibd=this.modal_create.form.ibdPipeline+this.modal_create.form.ibdDirectorateCost

      // this.modal_create.form.total_directorateCost=this.modal_create.form.marketingDirectorateCost+
      // this.modal_create.form.corporateDirectorateCost+this.modal_create.form.financeDirectorateCost
      // this.modal_create.form.operationDirectorateCost+this.modal_create.form.technologyDirectorateCost
      // this.modal_create.form.ibdDirectorateCost
    },
    handleRemove() {
      this.modal_create.fileList = [];
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
          this.modal_create.fileList = [];
          this.modal_create.fileList.push(file);
        return false;
      }
    },
    handlePanelChange2(value, mode){
      this.modal_create.form.periode = value
    },
    handlePanelOK(){
      if (this.modal_create.form.type) {
        this.changeType()
      }
    },
    async changeType(){
      this.loading.getalocation = true
      await this.asyncAxiosGet("plafon/last_liability_plafon",
        this.getAuth, {
          type: this.modal_create.form.type,
          start_periode: moment(this.modal_create.form.periode[0]).format(this.getStandartFormatDate),
          end_periode:moment(this.modal_create.form.periode[1]).format(this.getStandartFormatDate),
        }
      )
      .then(async (res) => {
        let invalidPeriode = false

        let z_star_periode = this.modal_create.form.periode[0] ? this.moment(this.modal_create.form.periode[0]).format('YYYY-MM') : null
        let z_end_periode = this.modal_create.form.periode[1] ? this.moment(this.modal_create.form.periode[1]).format('YYYY-MM') : null
        if(res.last_plafon[0] && 
          (this.moment(res.last_plafon[0].month_start).format('YYYY-MM')!=z_star_periode) &&
          (this.moment(res.last_plafon[0].month_end).format('YYYY-MM')!=z_end_periode)
        ){
          this.modal_create.form.est_total_pipeline = 0
          this.modal_create.form.est_total_directorateCost = 0
          this.modal_create.form.total_est_contract_value = 0
          this.modal_create.form.actual_value_cashflow = 0

          this.modal_create.form.marketing = 0
          this.modal_create.form.corporate = 0
          this.modal_create.form.finance = 0
          this.modal_create.form.operation = 0
          this.modal_create.form.technology = 0
          this.modal_create.form.ibd = 0

          this.modal_create.form.marketingPipeline = 0
          this.modal_create.form.corporatePipeline = 0
          this.modal_create.form.financePipeline = 0
          this.modal_create.form.operationPipeline = 0
          this.modal_create.form.technologyPipeline = 0
          this.modal_create.form.ibdPipeline = 0

          this.modal_create.form.marketingDirectorateCost = 0
          this.modal_create.form.corporateDirectorateCost = 0
          this.modal_create.form.financeDirectorateCost = 0
          this.modal_create.form.operationDirectorateCost = 0
          this.modal_create.form.technologyDirectorateCost = 0
          this.modal_create.form.ibdDirectorateCost = 0

          this.modal_create.form.allocatedMarketing = 0
          this.modal_create.form.allocatedCorporate = 0
          this.modal_create.form.allocatedFinance = 0
          this.modal_create.form.allocatedOperation = 0
          this.modal_create.form.allocatedTechnology = 0
          this.modal_create.form.allocatedIbd = 0

          this.modal_create.form.marketingListAPCost = 0
          this.modal_create.form.corporateListAPCost = 0
          this.modal_create.form.financeListAPCost = 0
          this.modal_create.form.operationListAPCost = 0
          this.modal_create.form.technologyListAPCost = 0
          this.modal_create.form.ibdListAPCost = 0
        }else{
          this.modal_create.form.est_total_pipeline = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].total_pipeline_plafon):0
          this.modal_create.form.est_total_directorateCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].total_biaya_direktorat):0
          this.modal_create.form.total_est_contract_value = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].total_plafon?res.last_plafon[0].total_plafon:0):0
          this.modal_create.form.actual_value_cashflow = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].est_cast_flow_value):0

          this.modal_create.form.marketing = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].marketing_plafon):0
          this.modal_create.form.corporate = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].corporate_plafon):0
          this.modal_create.form.finance = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].finance_plafon):0
          this.modal_create.form.operation = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].operation_plafon):0
          this.modal_create.form.technology = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].technology_plafon):0
          this.modal_create.form.ibd = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].international_business_development_plafon):0

          this.modal_create.form.marketingPipeline = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].marketing_pipeline_plafon):0
          this.modal_create.form.corporatePipeline = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].corporate_pipeline_plafon):0
          this.modal_create.form.financePipeline = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].finance_pipeline_plafon):0
          this.modal_create.form.operationPipeline = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].operation_pipeline_plafon):0
          this.modal_create.form.technologyPipeline = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].technology_pipeline_plafon):0
          this.modal_create.form.ibdPipeline = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].international_business_development_pipeline_plafon):0

          this.modal_create.form.marketingDirectorateCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].marketing_biaya_direktorat):0
          this.modal_create.form.corporateDirectorateCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].corporate_biaya_direktorat):0
          this.modal_create.form.financeDirectorateCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].finance_biaya_direktorat):0
          this.modal_create.form.operationDirectorateCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].operation_biaya_direktorat):0
          this.modal_create.form.technologyDirectorateCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].technology_biaya_direktorat):0
          this.modal_create.form.ibdDirectorateCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].international_business_development_biaya_direktorat):0

          this.modal_create.form.marketingListAPCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].marketing_list_ap_value):0
          this.modal_create.form.corporateListAPCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].corporate_list_ap_value):0
          this.modal_create.form.financeListAPCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].finance_list_ap_value):0
          this.modal_create.form.operationListAPCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].operation_list_ap_value):0
          this.modal_create.form.technologyListAPCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].technology_list_ap_value):0
          this.modal_create.form.ibdListAPCost = res.last_plafon[0] && !invalidPeriode?Number(res.last_plafon[0].international_business_development_list_ap_value):0

          this.modal_create.form.allocatedMarketing = Number(res.last_plafon[0].marketing_allocated_value)
          this.modal_create.form.allocatedCorporate = Number(res.last_plafon[0].corporate_allocated_value)
          this.modal_create.form.allocatedFinance = Number(res.last_plafon[0].finance_allocated_value)
          this.modal_create.form.allocatedOperation = Number(res.last_plafon[0].operation_allocated_value)
          this.modal_create.form.allocatedTechnology = Number(res.last_plafon[0].technology_allocated_value)
          this.modal_create.form.allocatedIbd = Number(res.last_plafon[0].international_business_development_allocated_value)
        }

        this.recountPlafon()
        this.recountPipeline()
        this.recountDirectorateCost()
        this.loading.getalocation = false
      })
      .catch((error)=>{
        this.loading.getalocation = false
        this.clearDetailModalForm()
        let responses = Object.assign({}, error.response.data);
        this.displayMessageValue("error-other", responses.message);
      })
    },
    changetotalPipeline(val){
      this.modal_create.form.total_est_contract_value = 
        (this.modal_create.form.est_total_directorateCost?this.modal_create.form.est_total_directorateCost:0) + (val?val:0)
    },
    changetotalDirectorateCost(val){
      this.modal_create.form.total_est_contract_value = 
        (this.modal_create.form.est_total_pipeline?this.modal_create.form.est_total_pipeline:0) + (val?val:0)
    },
    setSelectedtoNull(){
      this.selected.type = null
      this.selected.periode =  null
      this.selected.version = null
      this.allowtoFillDataFetching = false
    },
    setSelectedtoActive(){
      this.selected.type = this.data_header.type_monthly
      this.selected.periode =  this.data_header.type_monthly+"~"+this.data_header.month_start+"~"+this.data_header.month_end
      this.selected.version = this.data_header.version
    },
    refresh(){
      if(this.selected.version){
        this.fetch()
      }else{
        this.displayMessageValue("basic-info", "Please Select the version first!");
      }
    },
  },
  created() {
    this.setSelectedtoNull()
    this.fetch()
  },
  mounted(){
    Event.$on("setPriorityPlafon", this.setPriorityPlafon);
    Event.$on("unSetPriorityPlafon", this.unSetPriorityPlafon);
    Event.$on("setShortingPriorityPlafon", this.setShortingPriorityPlafon);
  },
  beforeDestroy() {
    Event.$off("setPriorityPlafon", this.setPriorityPlafon);
    Event.$off("unSetPriorityPlafon", this.unSetPriorityPlafon);
    Event.$off("setShortingPriorityPlafon", this.setShortingPriorityPlafon);
  }
}
</script>
<style lang="less">
.c_monthlyPlafon.mobilesscreen{
  .ant-card-body{
    padding: 0px!important;
  }
  .ant-collapse-content-box{
    padding: 0px!important;
  }
}
.c_monthlyPlafon {
  .ant-card-head-title{
    margin-right: 0px!important;
  }
  .cmain-title{
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }
  .cbtn-create {
    i {color: #fff;}
    path{color: #fff;}
    span {color: #fff;}
  }
  .hdr_plfn{
    .ant-table-title{
      padding-bottom: 0px;
    }
  }
  .option_plfn{
    td{
    padding: 0px;
    }
  }
  .hdr_plfn_selection{
    padding: 16px;
    cursor: pointer;
  }
  .hdr_plfn_selection.isfocused  {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25), inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }
  .row-ecv{
    .ant-input-number{
      justify-content: flex-end;
    }
    .ant-input-number-input{
      text-align: right;
      display: block;
    }
  }
  .row_h{
    margin-right: 11px;
  }
}
.cMonthlyfromcreate{
  .ant-input-number-input {
    text-align: right;
    padding-right: 25px;
  }
}

  .h_MCMAP{
    &-h_col{
      flex-direction: column;
    }
    display: flex;
    .ant-col{
      display: flex;
      flex-direction: column;
    //   .ant-collapse{
    //     display: flex;
    //     flex-direction: column;
    //     flex: 1;
    //     .ant-collapse-item{
    //       display: flex;
    //       flex-direction: column;
    //       flex: 1;
    //       .ant-collapse-header{
    //         display: flex;
    //       }
    //       .ant-collapse-content{
    //         display: flex;
    //         flex-direction: column;
    //         flex: 1;
    //         .ant-collapse-content-box{
    //           flex-grow: 1;
    //           .ant-card{
    //             height: 100%;
    //           }
    //         }
    //       }
    //     }
    //   }
    }
    .dtlplafons{
      display: flex;
      flex:1;

      .ant-collapse{
        display: flex;
        flex:1;
        flex-direction: column;
        .ant-collapse-item{
          display: flex;
          flex-direction: column;
          flex: 1 1 auto;
          .ant-collapse-content-active{
            display: flex;
            flex-grow: inherit;
            .ant-collapse-content-box{
              flex-grow: inherit;
              display: flex;
              flex-direction: column;
              .monthlytbl{
                flex-grow: inherit;
                display: flex;
                flex-direction: column;
                .ant-table-wrapper{
                  display: flex;
                  flex-grow: inherit;
                }
              }
            }
          }
        }
      }
    }
  }

  .mdl_input{
    row-gap: 0px;
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    .ant-form-item-label{
      width: 50%;
      display: flex;
    }
    .ant-form-item-control-wrapper{
      width: 50%;
    }
  }
</style>